var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-list-item__req-item"},[(_vm.img_icon_name)?_c('img',{attrs:{"src":`/images/icons/${_vm.img_icon_name}.svg`,"alt":_vm.img_icon_name}}):_vm._e(),_vm._v(" "),_c(_vm.slot_tag,{tag:"component",class:{loader: _vm.loading}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }